<section class="pt-8">
  <div class="max-w-5xl pt-12 mx-auto">
    <div
      class="bg-(--color-secondary) rounded-2xl overflow-hidden grid md:grid-cols-2 items-center justify-center"
    >
      <!-- right image -->
      <div>
        <img
          src="/images/section1.png"
          alt="wheat"
          class="object-cover w-full h-full"
          fetchpriority="high"
        />
      </div>

      <!-- left content -->
      <div class="flex flex-col items-center justify-center p-12 text-center">
        <div
          class="relative w-fit flex items-end text-(--color-main) font-extrabold leading-none"
          dir="ltr"
        >
          <span class="text-[120px]">76</span>
          <span class="text-[60px] leading-none mb-3">%</span>
        </div>
        <h2 class="text-4xl font-semibold text-white">عوائد سنوية متوقعة تصل الي</h2>
      </div>
    </div>
  </div>
</section>
